import React, { Fragment } from 'react'
import classNames from 'classnames'
import { Link } from 'libs/router'

const Guidebook = (props) => {
  const { title, description, lead, image, url, inverse = false } = props

  let imageBlock = null

  const classes = classNames('w-full md:w-2/4', {
    'md:ml-8': !inverse,
    'md:mr-8': inverse
  })

  let contentBlock = (
    <div className={classes}>
      <Link to={url} className='text-4xl font-bold mb-3 text-black block'>
        {title}
      </Link>
      <div className='text-lg leading-normal mb-3'>{lead || description}</div>
      <Link to={url} className='text-primary hover:underline text-lg'>
        read more
      </Link>
    </div>
  )

  if (image) {
    imageBlock = (
      <div className='w-full md:w-2/4 mb-6'>
        <Link to={url}>
          <img src={image.url} className='w-full' alt={title} />
        </Link>
      </div>
    )
  }

  return (
    <div className='flex items-start flex-wrap md:flex-no-wrap mb-32'>
      {!inverse && (
        <Fragment>
          {imageBlock} {contentBlock}
        </Fragment>
      )}
      {inverse && (
        <Fragment>
          {contentBlock} {imageBlock}
        </Fragment>
      )}
    </div>
  )
}

export default Guidebook
